import sliceCreator from '../../index.js';
import {GET_REPORT} from '../../../constants/index.js';
const _getDamageReportAction = sliceCreator('GET_REPORT',GET_REPORT, 'get');

const { asyncAction: getDamageReportAction, reducer, clearData: clearGetDamageReportAction } = _getDamageReportAction;

export default reducer;

export {
    getDamageReportAction,
    clearGetDamageReportAction
}


